import script from "./ModalDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDelete.vue?vue&type=script&setup=true&lang=js"

import "./ModalDelete.vue?vue&type=style&index=0&id=db756b1e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db756b1e"]])

export default __exports__